var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('asf-page-form-builder',{attrs:{"form-config":_vm.$store.state.AsfForms.forms.developmentOverview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }